import React from "react";

import CustomFields from "./index";

// eslint-disable-next-line react/display-name
const withSelect = (Component, value) => ({ ...props }) => (
  <>
    <CustomFields value={value} />
    <Component {...props} />
  </>
);

export default withSelect;
